var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnosis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 412,
    viewBox: "0 0 412 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgb(255 255 255 / 0.7)",
    strokeWidth: 2,
    fill: "rgb(255 255 255 / 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.4 234.2C133.7 234.2 145 230 154 223L79.1 148.1C72.1 157.1 67.9 168.4 67.9 180.7C68 210.3 91.9 234.2 121.4 234.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 180.8C344 168.5 339.8 157.2 332.8 148.2L258 223.1C267 230.1 278.3 234.3 290.6 234.3C320.1 234.2 344 210.3 344 180.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7 99.4L348.6 132.5C359.5 145.6 366.2 162.5 366.2 180.8C366.2 222.4 332.3 256.3 290.7 256.3C272.3 256.3 255.5 249.7 242.4 238.7L206 275L169.7 238.7C156.6 249.6 139.7 256.3 121.4 256.3C79.8 256.3 45.9 222.4 45.9 180.8C45.9 162.4 52.5 145.6 63.5 132.5L46.5 115.5L30.4 99.4C11.6 130.4 0.699997 166.8 0.699997 205.8C0.699997 319.2 92.6 411.2 206.1 411.2C319.6 411.2 411.5 319.3 411.5 205.8C411.4 166.8 400.5 130.4 381.7 99.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6 64C317.2 24.9 264.5 0.399994 206 0.399994C147.5 0.399994 94.8 24.9 57.4 64C52.3 69.4 47.5 75 43 80.9L206 243.9L369 80.9C364.5 75 359.7 69.4 354.6 64ZM206 27.3C254 27.3 298.7 45.8 332.3 79.6L206 205.8L79.8 79.6C113.3 45.8 158 27.3 206 27.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosis);
export default __webpack_public_path__ + "static/media/gnosis.db6d91a1dcaae9530938df22ffcb24b3.svg";
export { ForwardRef as ReactComponent };